export const makeBeatportUrl = (item) => {
  switch (item.type) {
    case 'track':
      return `https://www.beatport.com/track/${item.slug}/${item.id}`
    default:
      return 'https://www.beatport.com';
  }
}
